import React, { useCallback, useState } from 'react';
import c from 'classnames';
import { deleteSelection } from 'prosemirror-commands';

import useToggle from '@lyearn/core/hooks/useToggle';
import { Close } from '@lyearn/icons';
import { useReactNodeView } from '@lyearn/lygo-core';
import { Box, DeprecatedIconButton, InputBase } from '@lyearn/ui';

import { selectionType, setSelection } from '../../../utils';
import {
  blankContainerStyles,
  closeButtonStyles,
  inputAutoWidthStyles,
  questionEditorStyles,
} from './styles';

const BlankNodeView: React.FC = () => {
  const { node, view, getPos, updateAttrs } = useReactNodeView();
  const [blankText, setBlanktext] = useState(node?.attrs.text || '');
  const [isInputFocused, { on, off }] = useToggle(false);

  const onInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const updatedText = event.target.value;
      setBlanktext(updatedText);
      updateAttrs({ text: updatedText });
    },
    [updateAttrs],
  );

  const removeNode = () => {
    const posn = typeof getPos === 'function' ? getPos() : null;
    if (!view || !posn) {
      return;
    }
    setSelection(view, selectionType.NODE, posn);
    deleteSelection(view.state, view.dispatch);
    view.focus();
  };

  return (
    <Box
      className={c(
        'group relative mx-8 inline-block rounded-8 border border-field bg-bg-primary px-12 hover:shadow-01',
        { 'shadow-01': isInputFocused },
        blankContainerStyles,
      )}>
      <DeprecatedIconButton
        className={c(
          'absolute top-0 translate-x-1/2 -translate-y-1/2 transform end-0 group-hover:opacity-100',
          closeButtonStyles,
          { 'opacity-0': !isInputFocused },
        )}
        onClick={removeNode}>
        <Close />
      </DeprecatedIconButton>
      <InputBase
        autoFocus
        className={c('heading-m', inputAutoWidthStyles(blankText.length), questionEditorStyles)}
        placeholder="blank"
        value={blankText}
        onBlur={off}
        onChange={onInputChange}
        onFocus={on}
      />
    </Box>
  );
};

export default BlankNodeView;
